
document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const nav=document.querySelector('.nav');
  let navFrame=0;
  const setNav=()=>{
    navFrame=0;
    const shouldStick=window.scrollY>20;
    if(nav&&nav.classList.contains('scrolled')!==shouldStick)nav.classList.toggle('scrolled',shouldStick);
  };
  const onScroll=()=>{if(!navFrame)navFrame=requestAnimationFrame(setNav);};
  setNav(); window.addEventListener('scroll',onScroll,{passive:true});
  const revealEls=document.querySelectorAll('.reveal');
  if(revealEls.length){
    const skipRevealObserver=window.matchMedia('(max-width: 749px), (prefers-reduced-motion: reduce)').matches;
    if(skipRevealObserver){revealEls.forEach(el=>el.classList.add('visible'));}
    else if('IntersectionObserver' in window){
      const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');io.unobserve(e.target);}}),{threshold:.08});
      revealEls.forEach(el=>io.observe(el));
    }else{revealEls.forEach(el=>el.classList.add('visible'));}
  }
  const firstAcc=document.querySelector('.info-acc');
  if(firstAcc){firstAcc.classList.add('open');firstAcc.querySelector('.info-acc-btn')?.setAttribute('aria-expanded','true');}
});
document.addEventListener('click',e=>{
  const mobile=e.target.closest('.mobile-toggle');
  if(mobile){const menu=document.querySelector('.mobile-menu');const open=menu?.classList.toggle('open');mobile.setAttribute('aria-expanded',open?'true':'false');}
  const faq=e.target.closest('.faq-btn');
  if(faq){const item=faq.closest('.faq-item'),scope=item?.parentElement,was=item?.classList.contains('open');scope?.querySelectorAll('.faq-item').forEach(x=>{x.classList.remove('open');x.querySelector('.faq-btn')?.setAttribute('aria-expanded','false');});if(!was){item?.classList.add('open');faq.setAttribute('aria-expanded','true');}}
  const acc=e.target.closest('.info-acc-btn');
  if(acc){const item=acc.closest('.info-acc'),scope=item?.parentElement,was=item?.classList.contains('open');scope?.querySelectorAll('.info-acc').forEach(x=>{x.classList.remove('open');x.querySelector('.info-acc-btn')?.setAttribute('aria-expanded','false');});if(!was){item?.classList.add('open');acc.setAttribute('aria-expanded','true');}}
  const thumb=e.target.closest('.gallery-thumb');
  if(thumb){document.querySelectorAll('.gallery-thumb').forEach(x=>x.classList.remove('active'));thumb.classList.add('active');const main=document.querySelector('[data-main-product-image]');if(main&&thumb.dataset.image){main.src=thumb.dataset.image;main.srcset='';main.alt=thumb.dataset.alt||main.alt;}}
  const qty=e.target.closest('[data-quantity-change]');
  if(qty){const input=document.querySelector('[data-quantity-input]');if(input){input.value=Math.max(1,Number(input.value||1)+Number(qty.dataset.quantityChange));input.dispatchEvent(new Event('change',{bubbles:true}));}}
});
document.addEventListener('change',e=>{
  if(e.target.matches('[data-pack-radio]')){document.querySelectorAll('.pack-option').forEach(x=>x.classList.remove('selected'));e.target.closest('.pack-option')?.classList.add('selected');updateProductTotals(e.target);}
  if(e.target.matches('[data-quantity-input]'))updateProductTotals(e.target);
});
function updateProductTotals(source){
  const form=source.closest('form')||document.querySelector('[data-product-form]');if(!form)return;
  const selected=form.querySelector('[data-pack-radio]:checked');const qty=form.querySelector('[data-quantity-input]');
  const price=Number(selected?.dataset.price||0)/100,count=Number(qty?.value||1),subtotal=price*count;
  const sub=document.querySelector('[data-subtotal]');const coins=document.querySelector('[data-coins]');
  if(sub)sub.textContent=new Intl.NumberFormat('en-PK',{style:'currency',currency:'PKR',maximumFractionDigits:0}).format(subtotal).replace('PKR','Rs.');
  if(coins)coins.textContent=Math.round(subtotal*.825).toLocaleString('en-PK');
}
// Pre-select a pack option when a ?variant=ID is present in the URL (for ad deep-links)
document.addEventListener('DOMContentLoaded',()=>{
  try{
    const params=new URLSearchParams(window.location.search);
    const variantId=params.get('variant');
    if(!variantId)return;
    const radios=document.querySelectorAll('[data-pack-radio]');
    let matched=null;
    radios.forEach(r=>{ if(String(r.value)===String(variantId)) matched=r; });
    if(matched){
      radios.forEach(r=>r.checked=false);
      matched.checked=true;
      document.querySelectorAll('.pack-option').forEach(x=>x.classList.remove('selected'));
      matched.closest('.pack-option')?.classList.add('selected');
      updateProductTotals(matched);
    }
  }catch(err){}
});
